import FormmatedText from "pages/_components/CustomText/_components/FormmatedText";
import React from "react";
import { buttonOptionPropType, defaultButtonOptionPropType } from "../customButtonPropType";

const CustomButtonOption = ({ func, icon, disabled, ...textProps }) => {
    // Incluir todas estas clases a custom-button-option
    const customClass = `dropdown__item-btn btn btn-link btn-block custom-button-option ${textProps.className}`;

    const funcPlusStopPropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
        func();
    };

    return (
        <button onClick={funcPlusStopPropagation} className={customClass} type="button" disabled={disabled}>
            <FormmatedText text={textProps.text} textType={textProps.textType} />
        </button>
    );
};

CustomButtonOption.propTypes = buttonOptionPropType;
CustomButtonOption.defaultProps = defaultButtonOptionPropType;

export default CustomButtonOption;
